<template>
	<div grey-back full-height>

    <v-toolbar flat fixed>
        <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
        <v-toolbar-title class="white--text">Bluetooth Devices</v-toolbar-title>

        <!-- <v-btn color="primary" small flat @click="fn_callBackgroundView">print</v-btn> -->
    </v-toolbar>

    <!-- <div class="hasToolbar">
        <v-tabs fixed-tabs centered v-model="activeIndex" @input="fn_tabChange" slider-color="primary">
            <v-tab v-for="(tab, index) in tabs" :key="index" ripple><span :capitalized="tab.title == 'Bluetooth'"></span> {{tab.title}}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeIndex" @input="fn_tabChange">

            <v-tab-item>  
                <keep-alive>
                    <v-alert color="info" :value="true" v-if="$route.query.nodevice">
                        <div font-medium>
                            <div class="mb-2">Error in printing! Try following:</div>
                        <ul>
                            <li>Switch on your printer if not already and retry.</li>
                            <li>Restart your printer and retry.</li>
                            <li>Try connecting the printer from below list of devices.</li>
                            <li>Scan your device if not listed already.</li>
                        </ul>
                        </div>
                        <div center-align class="mt-1"><v-btn class="primary-color" flat @click="fn_getDefaultPrinter"><v-icon class="mr-2">refresh</v-icon> Retry</v-btn></div>
                    </v-alert>
                    
                <div>
                    <v-list two-line>
                        <v-subheader>Paired Devices <v-spacer></v-spacer> <v-btn icon><v-icon @click="fn_getDevices">refresh</v-icon></v-btn></v-subheader>
                        <v-list-tile v-for="(item, index) in pairedList.pairedDevices" :key="index" v-if="pairedList.pairedDevices && pairedList.pairedDevices.length">
                            <v-list-tile-content>
                                <v-list-tile-title>{{item.name}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ item.address }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn color="primary" flat @click="fn_connectDevice(item)">Select</v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                    <v-list two-line class="mt-2">
                        <v-subheader class="pr-0">New Devices <v-spacer></v-spacer> <v-btn color="primary" @click="fn_scanDevices" flat capitalize>Scan New Devices</v-btn></v-subheader>

                        <v-list-tile v-for="(item, index) in scannedDevices" :key="index" v-if="scannedDevices && scannedDevices.length">
                            <v-list-tile-content>
                                <v-list-tile-title>{{item.name}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{ item.address }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-btn color="primary" flat @click="fn_pairDevice(item)">Pair</v-btn>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                </div>
                </keep-alive>
            </v-tab-item>

            <v-tab-item>  
                <keep-alive>
                        usb devices
                </keep-alive>
            </v-tab-item>

        </v-tabs-items>
    </div> -->
    

    <div class="hasToolbar">

        <v-alert color="info" :value="true" v-if="$route.query.nodevice">
            <div font-medium>
                <div class="mb-2">Error in printing! Try following:</div>
            <ul>
                <li>Switch on your printer if not already and retry.</li>
                <li>Restart your printer and retry.</li>
                <li>Try connecting the printer from below list of devices.</li>
                <li>Scan your device if not listed already.</li>
            </ul>
            </div>
            <div center-align class="mt-1"><v-btn class="primary-color" flat @click="fn_getDefaultPrinter"><v-icon class="mr-2">refresh</v-icon> Retry</v-btn></div>
        </v-alert>
        
      <div>
        <v-list two-line>
            <v-subheader>Paired Devices <v-spacer></v-spacer> <v-btn icon><v-icon @click="fn_getDevices">refresh</v-icon></v-btn></v-subheader>
            <v-list-tile v-for="(item, index) in pairedList.pairedDevices" :key="index" v-if="pairedList.pairedDevices && pairedList.pairedDevices.length">
                <v-list-tile-content>
                    <v-list-tile-title>{{item.name}}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ item.address }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-btn color="primary" flat @click="fn_connectDevice(item)">Select</v-btn>
                </v-list-tile-action>
            </v-list-tile>
        </v-list>
        <v-list two-line class="mt-2">
            <v-subheader class="pr-0">New Devices <v-spacer></v-spacer> <v-btn color="primary" @click="fn_scanDevices" flat capitalize>Scan New Devices</v-btn></v-subheader>

            <v-list-tile v-for="(item, index) in scannedDevices" :key="index" v-if="scannedDevices && scannedDevices.length">
                <v-list-tile-content>
                    <v-list-tile-title>{{item.name}}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ item.address }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-btn color="primary" flat @click="fn_pairDevice(item, index)">Pair</v-btn>
                </v-list-tile-action>
            </v-list-tile>
        </v-list>
      </div>
           
    </div>

</div>
</template>

<script>
export default{
    data(){
        return{
            pairedList:{pairedDevices:null},
            scannedDevices:[],
            tabs:[
                {"id":1, "title":"Bluetooth"},
                {"id":2, "title":"USB"}
            ],
            // currentBalance:null,
            activeIndex:0,
        }
    },
    methods:{

        fn_enableBluetooth: function () {
            let self = this;
            this.getData('EnableBluetooth', null, 
                {
                onSuccess: function(response){
                    console.log(response);
                    self.fn_checkBluetoothPermission();
                }, 
                onError: function(error){
                    console.log(error);
                }
            });
        },

        fn_checkBluetoothPermission: function () {
            let self = this;
            this.getData('CheckBluetoothPermission', null, 
                {
                onSuccess: function(response){
                    self.fn_allPairedDeviceList();
                    console.log(response);
                }, 
                onError: function(error){
                    console.log(error);
                }
            });
        },

        fn_allPairedDeviceList: function () {
            let self = this;
            this.getData('AllPairedDeviceList', null, 
                {
                onSuccess: function(response){
                    console.log(response);
                    self.pairedList = JSON.parse(response);
                }, 
                onError: function(error){
                    console.log(error);
                }
            });
        },

        fn_getDefaultPrinter: function () {
			let self = this;
			this.getData('DefaultBluetoothPrinter', null, 
				{
				onSuccess: function(response){
					console.log(response);
					let data = JSON.parse(response);
					if(data.address && data.name){
						self.fn_connectDevice(data);
					}
					else{
						self.showToast('Select device to print');
					}
				}, 
				onError: function(error){
					console.log(error);
				}
			});
		},

        fn_connectDevice: function (item) {
            let self = this;
            // let dataObj = {"BTDeviceIndex":index};
            // self.fn_callBackgroundView();
            let imagePrint = (this.$root.selectedLanguage !== 'en' && this.$root.thermalPrintInSelectedLanguage) ? true : false;
            let dataObj = {"address":item.address, "name":item.name, "connectForImage":imagePrint};
            this.showLoading('Connecting with printer...');
            this.postData('ConnectToBluetoothDevice', dataObj, 
                {
                onSuccess: function(response){
                    console.log(response);
                    // self.fn_printReceipt();
                    self.hideLoading();
                    if(self.$route.query.setdefault){
                        self.fn_goBack();
                    }
                    else{
                        self.fn_callBackgroundView();
                    }
                }, 
                onError: function(error){
                    self.hideLoading();
                    console.log(error);
                    // if(error == 'Connection was interrupted'){
                    //     self.showToast('Unable to connect device');
                    // }
                    self.showToast('Unable to connect with device');
                    self.showToast('Select device to print');
                }
            });
        },

        fn_pairDevice: function (item, index) {
            let self = this;
            // let dataObj = {"BTDeviceIndex":index};
            let dataObj = {"address":item.address, "name":item.name};
            this.postData('PairToBluetoothDevice', dataObj, 
                {
                onSuccess: function(response){
                    console.log(response);
                    // self.scannedDevices.splice(index, 1);
                    self.fn_scanDevices();
                    self.fn_allPairedDeviceList();
                    // self.fn_printReceipt();
                }, 
                onError: function(error){
                    console.log(error);
                }
            });
        },

        fn_callBackgroundView: function () {
            // let dataObj = {"printThermalUrl":"http://192.168.1.102:8080/"};
            // let dataObj = {"printThermalUrl":"https://bizopsstaging-thermal-print.web.app"}
            self = this;
            let dataObj = JSON.parse(localStorage.getItem('receipt_data'));
            this.postData('CallBackgroundView', dataObj, 
                {
                onSuccess: function(response){
                    console.log(response);
                    let postObj = {"eventName":'thermal_print',"eventData":[{"eventKey":"transaction_number","eventValue":dataObj.invoiceData.transactionDetails.transactionNumber}]}
					self.$root.fn_postMetrics(postObj);
                    self.fn_goBack();
                }, 
                onError: function(error){
                    console.log(error);
                }
            });
        },

        fn_scanDevices: function () {
            let self = this;
            this.getData('ScanBluetooth', null, 
                {
                onSuccess: function(response){
                    console.log(response);
                    self.scannedDevices = JSON.parse(response);
                }, 
                onError: function(error){
                    console.log(error);
                }
            });
        },

        // fn_printReceipt: function(){
		// 		let data = `                 Business Name                  
		// 					Business Address Business Address Business Add 
		// 								ress Business Address              
		// 									GSTIN: XXXXXXXX                 
		// 						Email: abc@gmail.com / Ph No: 99XXXXXXXX    
																			
		// 									Tax Invoice                   
		// 					Invoice No: 99                Date: 01/03/2025 
		// 					Bill To: Customer Name                         
		// 					Customer Address                               
		// 					Customer Additional Details                    
		// 					Ship To: Customer Name                         
		// 					Customer Ship To Address                       
		// 					PO No: XXXX                                    
		// 					PO Date: XX-XX-XXXX                            
		// 					---------------------------------------------- 
		// 					#  Item                                        
		// 						Qty                  Rate          Amount 
		// 					---------------------------------------------- 
		// 					1  Sample ItemSample ItemSample ItemSample Ite 
		// 						m SampleItem SampleItem SampleItem SampleIt 
		// 						emSampleItemSampleItemSampleItemSampleItemS 
		// 						ampleItem                                   
		// 						Brand Name / Category                       
		// 						Note: ABCD                                  
		// 						10 Pcs             100.00 11,11,11,000.00 
		// 							Disc @5%:                        50.00 
		// 							GST @5%:                         47.50 
		// 							Item Net Amount:                997.50 
		// 					2  Test Item                                   
		// 						100 Pcs            200.00        20000.00 
		// 					---------------------------------------------- 
		// 						Items Total:                      21,000.00 
		// 						Discount:                            162.50 
		// 						CGST:                                 23.75 
		// 						SGST:                                 23.75 
		// 						Total Amount:                     20,997.50 
		// 						Received:                                 0 
		// 						Remaining Amount:                 20,997.50 
		// 					---------------------------------------------- 
		// 						Tax Summary                                 
		// 						CGST @2.5% on Amount:                 23.75 
		// 						SGST @2.5% on Amount:                 23.75 
		// 					---------------------------------------------- 
		// 								You Saved: XXXXXX                
		// 					---------------------------------------------- 
		// 					Note: Note values                              
		// 					Terms & Conditions:                            
		// 					All disputes are subject to Delhi jurisdictions `
		// 		let dataObj = {"printCommand":data};
		// 		this.postData('PrintReceipt', dataObj, 
		// 			{
		// 			onSuccess: function(response){
		// 				console.log(response);
		// 			}, 
		// 			onError: function(error){
		// 				console.log(error);
		// 			}
		// 		});
		// 	},

        fn_onNewScanDeviceFound: function(deviceData){
            let data = JSON.parse(deviceData)
            this.scannedDevices = data.scannedDevices;
        },

        fn_getDevices: function(){
            this.$root.fn_checkLocationPermission(()=>{
                this.fn_enableBluetooth();
            })
        },

        fn_tabChange:function(tabIndex){
            console.log(tabIndex);
        },

        fn_goBack: function(){
            this.$router.go(-1);
        },
    },
    mounted: function(){
        window.js_globals.fn_onBackPress = this.fn_goBack;
        window.js_globals.fn_onNewScanDeviceFound = this.fn_onNewScanDeviceFound;
        this.fn_getDevices();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/settings/bluetooth/devices.vue